﻿//
// import() requires CORS headers in response.
// we still need good ol's <script> for external resources
//
function addScript(scripts, success, error) {
	if (!Array.isArray(scripts)) {
		scripts = [scripts];
	}
	function addScriptImpl() {
		let scriptOptions = scripts.shift();
		if (typeof scriptOptions !== "object") {
			scriptOptions = { src: scriptOptions };
		}
		const script = document.createElement("script");
		if(error) {
			script.onerror = () => error(new Error(`Error loading script ${scriptOptions.src}`));
		}
		script.onload = script.onreadystatechange = function () {
			if (!this.readyState || /ded|co/.test(this.readyState)) {
				this.onload = this.onreadystatechange = this.onerror = null;
				if (!scripts.length) {
					success && success(script);
				} else {
					addScriptImpl();
				}
			}
		};
		script.async = true;
		for (const [key, value] of Object.entries(scriptOptions)) {
			if(value != null)
				script[key] = value;
		}
		// console.log(`Loading script: ${scriptOptions.src}`);
		document.head.append(script);
	}
	addScriptImpl();
}

/**
 * @param {string} src - URL(s) of the script(s) to load
 * @param {any} options - Optional attributes to set on the script element
 * @returns {Promise<HTMLScriptElement>} - Resolves when the script(s) are loaded, rejects on error
 */
async function addScriptAsync(src) {
	return new Promise((resolve, reject) => {
		addScript(src, resolve, reject);
	});
}

export { addScript, addScriptAsync };